import React from "react"
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { forgotPasswordRequest, passwordReset } from "../../api/api_auth"
import { validatePassword } from "../js/string_utils"

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)

    console.log("PasswordForgot props:", this.props)

    this.state = {
      isReadyToRender: false,
      variantPage: this.props.variantPage,
      errorMessage: "",
      email: "",
      password: "",
      passwordConfirm: "",
      resetValidationAvailable: false,
    }
    console.log("PasswordForgot state:", this.state)

    this.sendRequest = this.sendRequest.bind(this)
    this.sendReset = this.sendReset.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.handlePasswordConfirmChange = this.handlePasswordConfirmChange.bind(this)
  }

  componentDidMount() {
    this.setState({ isReadyToRender: true })
  }

  handleEmailChange(event) {
    this.setState({ email: event.target.value })
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value })
  }

  handlePasswordConfirmChange(event) {
    this.setState({ passwordConfirm: event.target.value })

    if (this.state.password !== event.target.value) {
      this.setState({ resetValidationAvailable: false, errorMessage: this.props.t("message.passwordsDoNotMatch") })
    } else if (!validatePassword(this.state.password)) {
      this.setState({ resetValidationAvailable: false, errorMessage: this.props.t("message.passwordDoesNotFollowSecurePolicy") })
    } else {
      this.setState({ resetValidationAvailable: true, errorMessage: "" })
    }
  }

  sendRequest(e) {
    e.preventDefault()

    Promise.all([forgotPasswordRequest(this.state.email)]).then((promisesResults) => {
      const [response] = promisesResults

      if (response.status === 204) {
        this.setState({ variantPage: "request_sent" })
      } else {
        this.setState({ errorMessage: this.props.t("message.errorOccuredContactAdmin") })
        setTimeout(() => this.setState({ errorMessage: "" }), 3000)
      }
    })
  }

  sendReset(e) {
    e.preventDefault()

    Promise.all([passwordReset(this.props.token, this.state.password)]).then((promisesResults) => {
      const [response] = promisesResults

      if (response.status === 204) {
        this.setState({ variantPage: "reset_confirm" })
        setTimeout(() => (window.location = "/"), 5000)
      } else {
        this.setState({ errorMessage: this.props.t("message.errorOccuredContactAdmin") })
        setTimeout(() => this.setState({ errorMessage: "" }), 3000)
      }
    })
  }

  render() {
    if (!this.state.isReadyToRender) {
      console.log("PASSWORD FORGOT render:", "not ready")
      return null
    }

    let errorAlert = ""
    if (this.state.errorMessage !== "") {
      errorAlert = (
        <Alert variant="danger" className="text-center">
          {this.state.errorMessage}
        </Alert>
      )
    }

    let cardTitle
    let cardBody
    if (this.state.variantPage === "request") {
      cardTitle = this.props.t("app.passwordForgot")
      cardBody = (
        <>
          <Form.Group controlId="formBasicEmail" className="text-center">
            <Form.Label>{this.props.t("message.pleaseEnterYourEmailAddress")}</Form.Label>
            <br />
            <Form.Control autoFocus className="width-300 display-inline" type="email" value={this.state.email} onChange={this.handleEmailChange} />
          </Form.Group>

          <Form.Group className="mb-3">{errorAlert}</Form.Group>

          <br />
          <p className="text-info text-center">{this.props.t("message.sendResetPasswordEmail")}</p>

          <Form.Group className="text-center">
            <Button variant="secondary" onClick={() => (window.location = "/")}>
              {this.props.t("action.back")}
            </Button>

            <Button className="margin-left-20" variant="primary" type="submit" onClick={this.sendRequest}>
              {this.props.t("action.send")}
            </Button>
          </Form.Group>
        </>
      )
    } else if (this.state.variantPage === "request_sent") {
      cardTitle = this.props.t("app.passwordForgot")
      cardBody = (
        <>
          <Alert variant="success" className="text-center">
            <div dangerouslySetInnerHTML={{ __html: this.props.t("message.passwordForgotEmailSentFollowInstructions") }} />
          </Alert>
          <div className="text-center">{this.props.t("message.youCanCloseThisWindow")}</div>
        </>
      )
    } else if (this.state.variantPage === "reset") {
      cardTitle = this.props.t("app.passwordReset")
      cardBody = (
        <>
          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>{this.props.t("form.password")}</Form.Label>
            <Form.Control type="password" value={this.state.password} onChange={this.handlePasswordChange} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formPasswordConfirm">
            <Form.Label>{this.props.t("form.passwordConfirm")}</Form.Label>
            <Form.Control type="password" value={this.state.passwordConfirm} onChange={this.handlePasswordConfirmChange} />
          </Form.Group>

          <Form.Group className="mb-3">{errorAlert}</Form.Group>

          <Alert variant="info" className="text-centersssss">
            <div dangerouslySetInnerHTML={{ __html: this.props.t("message.passwordSecurePolicy") }} />
          </Alert>
          <br />

          <Form.Group className="text-center" controlId="formBasicPassword">
            <Button variant="primary" disabled={!this.state.resetValidationAvailable} onClick={this.sendReset}>
              {this.props.t("action.validate")}
            </Button>
          </Form.Group>
        </>
      )
    } else if (this.state.variantPage === "reset_confirm") {
      cardTitle = this.props.t("app.passwordReset")
      cardBody = (
        <Alert variant="success" className="text-center">
          <div dangerouslySetInnerHTML={{ __html: this.props.t("message.passwordSuccessfullyChangedRedirection") }} />
        </Alert>
      )
    }

    return (
      <Container>
        <Row className="justify-content-md-center">
          <Col id="password-forgot-col" md="auto">
            <Form noValidate>
              <Card className="bg-dark text-white box-shadow-lvl3" style={{ width: "30rem" }}>
                <Card.Header as="h4" className="text-center margin-top-8">
                  {cardTitle}
                </Card.Header>
                <Card.Body>{cardBody}</Card.Body>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
    )
  }
}
export default withTranslation()(ForgotPassword)
